import { Node, mergeAttributes } from '@tiptap/core'

export default Node.create({
    name: "infoBox",
    content: "inline*",
    group: "block",
    defining: true,
    addAttributes() {
        return {
            type: {
                default: "info",
                renderHTML: attributes => {
                    return {
                        class: "alert alert-" + attributes.type
                    }
                }
            }
        }
    },
    renderHTML({ HTMLAttributes }) {
        return ["div", mergeAttributes(HTMLAttributes, { class: "d-flex align-items-center" }), ["i", { style: "font-size: 1.4em", class: "me-3 fas " + (HTMLAttributes.class === "alert alert-success" ? "fa-check-circle text-success" : HTMLAttributes.class === "alert alert-warning" ? "fa-exclamation-circle text-warning" : HTMLAttributes.class === "alert alert-danger" ? "fa-exclamation-triangle text-danger" : "fa-info-circle text-info") }], ["span", 0]];
    },
    addCommands() {
        return {
            toggleInfoBox: attributes => ({ commands }) => {
                return commands.toggleNode("infoBox", "paragraph", attributes);
            }
        }
    }
});
